import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    marker:
      'absolute top-1/2 left-1/2 flex -translate-x-1/2 -translate-y-1/2 cursor-pointer rounded-full',
    markerInner: 'bg-blue-dark block size-12 rounded-full border border-white'
  },
  variants: {
    isSelected: {
      true: {
        marker: 'border-4 border-white',
        markerInner: 'bg-icon-star border-main border-2'
      }
    }
  }
});
